import { MainContainer } from 'components/Container/Container.styled';
import styled, { createGlobalStyle, css } from 'styled-components';
import { themeable } from 'themes/utils';
import { absoluteMixin } from 'ui/Styled/Styled';
import {
    desktopMediaQuery,
    mobileMediaQuery,
    notDesktopMediaQuery,
    notMobileMediaQuery
} from 'utils/mediaQuery';
import { ReactComponent as RawCloseIcon } from 'assets/close.svg';

export const Overlay = styled.div`
    ${absoluteMixin}

    ${mobileMediaQuery(css`
        position: fixed;
        top: 0;
        background: ${themeable('sidebar.background')};
    `)}
`;

export const Wrapper = styled.div<SOpenProps>`
    z-index: 90;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-flow: column;

    ${({ $isOpen }) =>
        !$isOpen &&
        css`
            display: none;
        `}

    ${desktopMediaQuery(absoluteMixin)}

    ${notDesktopMediaQuery(css`
        position: fixed;
        top: 0;
        width: 100%;
        bottom: 0;
    `)}

    ${mobileMediaQuery(css`
        width: 100%;
    `)}
`;

export const Container = styled.div`
    position: relative;
    width: 100%;
    max-width: 700px;
    box-sizing: border-box;
    background: ${themeable('sidebar.background')};
    padding: 30px;
    max-height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    /* display: flex;
    align-items: center;
    justify-content: center;
    flex-flow: column; */

    & form {
        width: 100%;
    }

    ${notMobileMediaQuery(css`
        border-radius: 8px;
    `)}

    ${mobileMediaQuery(css`
        padding: 62px 24px;
        flex: 1;
        display: flex;
    `)}
`;

export const Inner = styled.div`
    ${mobileMediaQuery(css`
        margin: auto;
    `)}
`;

export const MainBlurStyle = createGlobalStyle`
    ${MainContainer} {
        filter: blur(3px);
    }
`;

export const CloseIcon = styled(RawCloseIcon)`
    position: absolute;
    top: 12px;
    right: 12px;
    width: 20px;
    height: auto;
    cursor: pointer;

    ${mobileMediaQuery(css`
        width: 24px;
        box-sizing: content-box;
        right: 12px;
        top: 12px;
        padding: 12px;
    `)}
`;
